export default "__VITE_ASSET__DSWdwdVn__"